module.exports = __webpack_public_path__ + "img/2.5e1c0a72.png";